import React, { Component } from "react";
import { Drawer } from "antd";
import ThemeConfigurator from "./ThemeConfigurator";
import { connect } from "react-redux";
import { DIR_RTL } from "constants/ThemeConstant";

export class NavPanel extends Component {
  state = { visible: false, staffsActivity: [] };

  showDrawer = () => {
    this.setState({
      ...this.state,
      visible: true,
    });
  };

  onClose = () => {
    this.setState({
      ...this.state,
      visible: false,
    });
  };

  render() {
    return (
      <>
        {/* <Menu mode="horizontal">
          <Menu.Item key="panel" onClick={this.showDrawer}>
            <span>
              <SettingOutlined className="nav-icon mr-0" />
            </span>
          </Menu.Item>
        </Menu> */}
        <Drawer
          title="Configuração do Tema"
          placement={this.props.direction === DIR_RTL ? "left" : "right"}
          width={350}
          onClose={this.onClose}
          visible={this.state.visible}
        >
          <ThemeConfigurator />
        </Drawer>
      </>
    );
  }
}

const mapStateToProps = ({ theme }) => {
  const { locale } = theme;
  return { locale };
};

export default connect(mapStateToProps)(NavPanel);
